import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './DhikrCards.css';

function BenefitTooltip({ onClick }) {
  const { t } = useLanguage();

  return (
    <div className="benefit-container">
      <button
        className="benefit-btn"
        onClick={(e) => { e.stopPropagation(); onClick(); }}
        title={t('adhkar_benefit_title')}
        aria-label={t('adhkar_benefit_aria')}
      >
        <span>؟</span>
      </button>
    </div>
  );
}

export function DhikrCard({ dhikr, initialCount, onComplete, onProgress, isEvening, onShowBenefit, onGlobalIncrement }) {
  const { t } = useLanguage();
  const [count, setCount] = useState(initialCount ?? dhikr.repeat);

  useEffect(() => {
    setCount(initialCount ?? dhikr.repeat);
  }, [initialCount, dhikr.repeat]);

  const handleClick = () => {
    if (count <= 0) return;
    // === Add Global Tasbeeh Synchronization for certain adhkar ===
    if (dhikr.text.includes("سبحان الله وبحمده") || dhikr.name === "التسبيح") {
      if (onGlobalIncrement) {
        onGlobalIncrement("سبحان الله وبحمده");
      }
    }
    // =============================================================

    if (count <= 1) {
      if (count === 1) { // Trigger only on the very last tap to reach 0
        setCount(0);
        onComplete(dhikr.id);
      }
    } else {
      const newCount = count - 1;
      setCount(newCount);
      if (onProgress) onProgress(dhikr.id, newCount);
    }
  };

  const progress = ((dhikr.repeat - count) / dhikr.repeat) * 100;

  return (
    <div className="dhikr-card" role="button" tabIndex={0} aria-label={`${dhikr.name} · ${count}`} onClick={handleClick} onKeyDown={event => {
      if (event.target === event.currentTarget && ['Enter', ' '].includes(event.key)) { event.preventDefault(); handleClick(); }
    }}>
      <div
        className="card-progress"
        style={{
          width: `${progress}%`,
          background: isEvening
            ? 'linear-gradient(90deg, var(--evening-mid), var(--evening))'
            : 'linear-gradient(90deg, var(--morning-mid), var(--morning))'
        }}
      />
      <div className="card-header">
        <span className="dhikr-name">{dhikr.name}</span>
        <div className="card-actions" onClick={e => e.stopPropagation()}>
          <BenefitTooltip onClick={() => onShowBenefit(dhikr.benefit)} />
        </div>
      </div>
      <p className="dhikr-text">{dhikr.text}</p>
      <div className="card-footer">
        <div className="count-badge">
          <span
            className="count-num"
            style={{ color: isEvening ? 'var(--evening)' : 'var(--morning)' }}
          >
            {count}
          </span>
          <span className="count-label">{count === 1 ? t('adhkar_once') : t('adhkar_times')}</span>
        </div>
        <span className="tap-hint">{t('adhkar_tap_hint')}</span>
      </div>
    </div>
  );
}

export function CompletedSection({ completed, allList }) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const items = allList.filter(d => completed.includes(d.id));
  return (
    <div className="completed-section">
      <button className="completed-toggle" onClick={() => setOpen(o => !o)}>
        {open ? "▲" : "▼"} {t('adhkar_completed_items', { count: items.length })} ✓
      </button>
      {open && items.map(d => (
        <div className="completed-item" key={d.id}>
          <div className="completed-item-name">
            <span className="done-check">✓</span>{d.name}
          </div>
          <div className="completed-item-text">{d.text}</div>
        </div>
      ))}
    </div>
  );
}
